import { anthracite } from '@styles/theme';
import { globalStyle, style } from '@vanilla-extract/css';

export const block = style({
  padding: '0.9375rem 1.25rem',
  borderRadius: '0.625rem',
  background: '#fff',
  zIndex: 2,
});

export const item = style({
  color: anthracite,
  fontSize: '0.875rem',
  display: 'flex',
  gap: '0.625rem',
  alignItems: 'center',
  selectors: {
    '&:not(:last-child)': { marginBottom: '1.25rem' },
  },
});
globalStyle(`${item} p`, {
  margin: 0,
  flex: 1,
  fontSize: '1rem',
  lineHeight: 1.4,
});
globalStyle(`${item} p span`, { fontWeight: 900 });
